import { allTechMeasuresProjectsCards } from '@/data/techAndMeasures/index';
import { getProjectDetail } from '@/services/tech-measures-service';
import type { TechMeasuresProjectCard, TechMeasuresProjectInfo } from '@/types';
import { ref, watchEffect } from 'vue';

export const useProjectDetail = <T extends { measure: string }>(props: T) => {
  const projectData = ref<TechMeasuresProjectInfo | null>(null);
  const otherRelatedMeasures = ref<TechMeasuresProjectCard[]>([]);

  watchEffect(() => {
    projectData.value = props.measure ? getProjectDetail(props.measure) : null;

    otherRelatedMeasures.value = projectData.value
      ? allTechMeasuresProjectsCards.value.filter(
          (project) =>
            project.typeId === projectData.value?.typeId && project.id !== projectData.value?.id
        )
      : [];
  });

  return { projectData, otherRelatedMeasures };
};
